import ServiceCategoryListPage from "./pages/ServiceCategoryListPage";
import ServiceCategoryCreatePage from "./pages/ServiceCategoryCreatePage";
import ServiceCategoryDetailPage from "./pages/ServiceCategoryDetailPage";
import ServiceCategorySortPage from "./pages/ServiceCategorySortPage";

export const serviceCategoryRoutes = (prefix = "service-categories") => [
  {
    name: "ServiceCategorySortPage",
    path: `${prefix}/sort`,
    component: ServiceCategorySortPage
  },
  {
    name: "ServiceCategoryCreatePage",
    path: `${prefix}/create`,
    component: ServiceCategoryCreatePage
  },
  {
    name: "ServiceCategoryDetailPage",
    path: `${prefix}/:id`,
    component: ServiceCategoryDetailPage
  },
  {
    name: "ServiceCategoryListPage",
    path: prefix,
    component: ServiceCategoryListPage
  }
];
